// Навигация по списку блюд ABC: единый фильтр (рекомендация, группа по прибыли или клетка матрицы), поиск,
// сортировка, первые 30. Чистые функции без React; распределение и матрица считаются по всем блюдам (buildMenuAbc).
import { ABC_TAGS } from './abcCalculations';

export const PAGE_SIZE = 30;

// Фильтр: null — нет; { kind: 'tag', tag } | { kind: 'group', letter } | { kind: 'cell', profit, qty } |
// { kind: 'change', direction: down|up|new, label } — динамика к прошлому периоду (abcDynamics)
export const tagFilter = (tag) => ({ kind: 'tag', tag });
export const changeFilter = (direction, label = '') => ({ kind: 'change', direction, label });
export const CHANGE_TITLES = { down: 'Упали', up: 'Выросли', new: 'Новые' };
export const groupFilter = (letter) => ({ kind: 'group', letter });
export const cellFilter = (profit, qty) => ({ kind: 'cell', profit, qty });

export function sameFilter(a, b) {
  if (!a || !b || a.kind !== b.kind) return false;
  if (a.kind === 'tag') return a.tag === b.tag;
  if (a.kind === 'group') return a.letter === b.letter;
  if (a.kind === 'change') return a.direction === b.direction;
  return a.profit === b.profit && a.qty === b.qty;
}

// Новый клик заменяет фильтр, повторный по тому же — снимает
export const toggleFilter = (current, next) => (sameFilter(current, next) ? null : next);

export function matchesFilter(dish, filter) {
  if (!filter) return true;
  if (filter.kind === 'tag') return dish.tag === filter.tag;
  if (filter.kind === 'group') return dish.abc.profit === filter.letter;
  // Упали / выросли — только заметные сдвиги (как в счётчиках «Что изменилось»); новые — все
  if (filter.kind === 'change') {
    return Boolean(dish.change) && dish.change.direction === filter.direction && (filter.direction === 'new' || dish.change.notable);
  }
  return dish.abc.profit === filter.profit && dish.abc.qty === filter.qty;
}

export function filterLabel(filter) {
  if (!filter) return '';
  if (filter.kind === 'tag') return `Рекомендация: ${ABC_TAGS[filter.tag]?.label || filter.tag}`;
  if (filter.kind === 'group') return `Группа ${filter.letter}`;
  if (filter.kind === 'change') return [CHANGE_TITLES[filter.direction], filter.label].filter(Boolean).join(' ');
  return `Продажи ${filter.qty}, прибыль ${filter.profit}`;
}

// Поиск: без учёта регистра, «ё» = «е», лишние пробелы не важны
export const normalizeText = (text) => String(text || '').toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();

export function matchesSearch(dish, query) {
  const needle = normalizeText(query);
  return !needle || normalizeText(dish.name).includes(needle);
}

export const SORT_FIELDS = {
  qty: 'Продано',
  revenue: 'Выручка',
  profit: 'Прибыль',
  profitPerPortion: 'Прибыль с порции',
};
export const DEFAULT_SORT = { field: 'profit', dir: 'desc' };

// Клик по той же колонке — другое направление; по новой — сначала по убыванию
export const toggleSort = (sort, field) =>
  sort.field === field ? { field, dir: sort.dir === 'desc' ? 'asc' : 'desc' } : { field, dir: 'desc' };

// Ничьи — по названию (по алфавиту при любом направлении)
export function sortDishes(dishes, sort = DEFAULT_SORT) {
  const sign = sort.dir === 'asc' ? 1 : -1;
  return [...dishes].sort((a, b) => sign * (a[sort.field] - b[sort.field]) || a.name.localeCompare(b.name, 'ru')
    || String(a.key ?? '').localeCompare(String(b.key ?? '')));
}

export const countMatching = (dishes, filter) => dishes.filter((dish) => matchesFilter(dish, filter)).length;

/**
 * Что показать в списке: фильтр + поиск + сортировка; без фильтра и поиска — первые PAGE_SIZE (если не showAll).
 * → { items, total (после фильтра и поиска), hidden (сколько скрыто ограничением) }
 */
export function visibleDishes(dishes, { filter = null, query = '', sort = DEFAULT_SORT, showAll = false } = {}) {
  const matching = sortDishes(dishes.filter((dish) => matchesFilter(dish, filter) && matchesSearch(dish, query)), sort);
  const limited = !filter && !normalizeText(query) && !showAll && matching.length > PAGE_SIZE;
  const items = limited ? matching.slice(0, PAGE_SIZE) : matching;
  return { items, total: matching.length, hidden: matching.length - items.length };
}
